require('element-matches-polyfill');

document.addEventListener("DOMContentLoaded", function() {

	let button = document.getElementById('back-to-top-button');
	let threshold = 1000;

	if(button) {
		window.addEventListener('scroll', function() {

			let active = button.classList.contains('totop-active');

			//if we're past the threshold and the button isn't currently visible
			if(window.pageYOffset >= threshold && !active) {
				button.classList.add('totop-active');
			} else if(window.pageYOffset < threshold && active) { //otherwise we're closer to the top and the button needs to be hidden
				button.classList.remove('totop-active');
			}
		});

		document.addEventListener('click', function (event) {

			// If the clicked element isn't the to top button, return
			if (!event.target.matches('#back-to-top-button')) return;

			window.scrollTo({top: 0, behavior: 'smooth'});

		}, false);
	}
});